// Project category options
export const PROJECT_CATEGORIES = [
  { value: 'vendor_assessment', label: '供應商評估' },
  { value: 'procurement', label: '採購管理' },
  { value: 'quality', label: '品質管理' },
  { value: 'esg', label: 'ESG' },
  { value: 'compliance', label: '合規' },
  { value: 'other', label: '其他' },
];

// Wizard steps configuration (里程碑步驟已移除)
export const STEPS = [
  { id: 1, name: '基本資訊', icon: '📋', description: '專案名稱與類型' },
  { id: 2, name: '時間範圍', icon: '📅', description: '設定專案期間' },
  { id: 3, name: '確認', icon: '✅', description: '審核並建立專案' }
];

// DEFAULT_MILESTONES 已移除 - 里程碑功能不再使用

// Initial form data
export const INITIAL_FORM_DATA = {
  // Step 1: Basic Info
  name: '',
  code: '',
  description: '',
  project_type: 'quarterly',
  category: 'vendor_assessment',
  status: 'draft',
  access_tags: [],

  // Step 2: Time Scope
  time_scope: {
    year: new Date().getFullYear(),
    quarter: 1,
    half: null,
    start_date: '',
    end_date: '',
  },

  // Resource Allocation
  form_template_ids: [],
  eligible_vendor_ids: [],
  eligible_vendor_tags: [],

  // Milestones 已移除

  // Settings
  settings: {
    auto_reminder: true,
    reminder_days: 3,
    allow_late_submission: false,
    require_approval: true,
  },
  team: {
    owner: '',
    managers: [],
  },
  tags: [],
  budget: {
    total: 0,
    currency: 'TWD',
  },
};
